import config from '@occc/config';

import { TabConfig } from './scan-data.types';

export const OVERVIEW_TAB_CONFIG: TabConfig = {
  label: 'Overview',
  value: 'overview',
  pageTitle: `${config.brandName} Scan Data`,
  pageSubtitle: 'Set SFTP credentials, manage store groups and submission status',
};

export const WEEKLY_FILE_TAB_CONFIG: TabConfig = {
  label: 'Weekly File',
  value: 'weekly-file',
  pageTitle: 'Process Submissions',
  pageSubtitle: config.brandName,
};

export const SUBMISSION_GROUPS_TAB_CONFIG: TabConfig = {
  label: 'Submission Groups',
  value: 'submission-groups',
  pageTitle: 'Submission Groups',
  pageSubtitle: config.brandName,
};
